




























































































































































import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import ResizeUpdateMixin from '@/common/ts/resizing/ResizeUpdateMixin';
import Accordion from '@/webcomponents/accordion/Accordion.vue';
import { sanitizeUrl } from '@braintree/sanitize-url';
import AccordionItem from '@/webcomponents/accordion/AccordionItem.vue';
import i18n from './i18n';
import { LEGAL_LINK_CLICKED_EVENT } from '../footer-navigation/FooterNavigationItem.vue';

const IconClose = () => import('@/common/icons/close-new.svg');

const LegalLayerProps = Vue.extend({
  props: {
    providerContent: String,
    legalContent: String,
    privacyContent: String,
    editMode: Boolean,
  },
});

@Component({
  methods: { sanitizeUrl },
  components: {
    AccordionItem,
    Accordion,
    IconClose,
  },
  i18n,
})
export default class LegalLayer extends mixins(LegalLayerProps, ResizeUpdateMixin) {
  $refs!: {
    overflowContent: HTMLElement;
    providerAccordion: AccordionItem;
    legalAccordion: AccordionItem;
    cookiesAccordion: AccordionItem;
    privacyAccordion: AccordionItem;
  };

  providerAnchor = this.$t('providerAnchor').toString();
  privacyAnchor = this.$t('privacyStatementAnchor').toString();
  legalNoticeAnchor = this.$t('legalNoticeAnchor').toString();
  cookiesAnchor = '#cookies';
  focusedTab = this.providerAnchor;
  open = false;

  get rootClass () {
    return {
      'brandhub-legal-layer--edit-mode': this.editMode,
    };
  }

  translatedTitle (prop: string) {
    const title = this.$t(prop).toString();
    return title || '';
  }

  changeTabFocus (elem: string) {
    this.focusedTab = elem;
    window.location.hash = '';
  }

  getFocusedClass (elem: string) {
    return {
      'brandhub-legal-layer__tab-name--selected': this.focusedTab === elem,
    };
  }

  sanitizedLegalItems (legalText: string) {
    return sanitizeUrl(legalText);
  }

  sanitizedProviderAnchor () {
    return sanitizeUrl(this.providerAnchor);
  }

  closeLegalLayer () {
    this.open = false;
    enableBodyScroll(this.$refs.overflowContent);
    window.location.hash = '';
  }

  openAccordion () {
    if (this.$refs.providerAccordion && this.$refs.legalAccordion
      && this.$refs.cookiesAccordion && this.$refs.privacyAccordion) {
      this.$refs.providerAccordion.open = false;
      this.$refs.legalAccordion.open = false;
      this.$refs.cookiesAccordion.open = false;
      this.$refs.privacyAccordion.open = false;

      if (this.focusedTab === this.providerAnchor) {
        this.$refs.providerAccordion.openContent();
      }

      if (this.focusedTab === this.legalNoticeAnchor) {
        this.$refs.legalAccordion.openContent();
      }

      if (this.focusedTab === this.cookiesAnchor) {
        this.$refs.cookiesAccordion.openContent();
      }

      if (this.focusedTab === this.privacyAnchor) {
        this.$refs.privacyAccordion.openContent();
      }
    }
  }

  setUpLegalLayer (focused: string) {
    this.focusedTab = focused;
    this.open = true;
    disableBodyScroll(this.$refs.overflowContent);
    this.openAccordion();
  }

  openLegalLayer (event: any) {
    if (event.detail) {
      if ([this.providerAnchor, this.cookiesAnchor, this.privacyAnchor, this.legalNoticeAnchor].includes(event.detail.toString())) {
        this.setUpLegalLayer(event.detail.toString());
      }
    } else if ([this.providerAnchor, this.cookiesAnchor, this.privacyAnchor, this.legalNoticeAnchor].includes(window.location.hash)) {
      this.setUpLegalLayer(window.location.hash);
    }
  }

  mounted () {
    if (window.location.hash) {
      if ([this.providerAnchor, this.cookiesAnchor, this.privacyAnchor, this.legalNoticeAnchor].includes(window.location.hash)) {
        this.setUpLegalLayer(window.location.hash);
      }
    }
    window.addEventListener(LEGAL_LINK_CLICKED_EVENT, this.openLegalLayer);
    window.addEventListener('hashchange', this.openLegalLayer);
  }
}

